/* Aussie Vital Fuel — theme behaviour.
   Everything here degrades gracefully: with JS off the header nav is a plain
   list, the FAQ uses native <details>, and every add-to-cart is a real form
   POST to /cart/add. */
(function () {
  'use strict';

  var settings = window.AVFSettings || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------- reveal */
  function initReveal() {
    var nodes = document.querySelectorAll('.reveal');
    if (!nodes.length) return;

    if (reduceMotion || !settings.animate || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }

    /* Anything already on screen is marked visible before the hidden state is
       armed, so above-the-fold sections never flash out and back in. */
    var vh = window.innerHeight || document.documentElement.clientHeight;
    nodes.forEach(function (n) {
      var box = n.getBoundingClientRect();
      if (box.top < vh && box.bottom > 0) n.classList.add('is-visible');
    });

    /* Only now arm the hidden state: the class goes on at the moment the
       observer is created, so the hiding can always be undone. */
    document.documentElement.classList.add('js-reveal');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    nodes.forEach(function (n) {
      if (!n.classList.contains('is-visible')) io.observe(n);
    });
  }

  /* ------------------------------------------------------------ header nav */
  function initHeader() {
    document.querySelectorAll('[data-nav-toggle]').forEach(function (toggle) {
      if (toggle.dataset.avfBound) return;
      toggle.dataset.avfBound = '1';
      var nav = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!nav) return;

      toggle.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape' || !nav.classList.contains('is-open')) return;
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      });
    });
  }

  /* -------------------------------------------------------------- accordion */
  function initAccordions() {
    document.querySelectorAll('[data-accordion]').forEach(function (list) {
      if (list.dataset.avfBound) return;
      list.dataset.avfBound = '1';
      if (list.dataset.accordion !== 'single') return;
      var items = list.querySelectorAll('details');
      items.forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          items.forEach(function (other) { if (other !== item) other.open = false; });
        });
      });
    });
  }

  /* ------------------------------------------------------------- back to top */
  function initBackToTop() {
    document.querySelectorAll('[data-back-to-top]').forEach(function (button) {
      if (button.dataset.avfBound) return;
      button.dataset.avfBound = '1';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  }

  /* ------------------------------------------------------------- cart drawer */
  var drawer = null;

  function getDrawer() {
    if (drawer === null) drawer = document.querySelector('[data-cart-drawer]');
    return drawer;
  }

  function openDrawer() {
    var el = getDrawer();
    if (!el) return false;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = el.querySelector('[data-cart-close]');
    if (close) close.focus();
    return true;
  }

  function closeDrawer() {
    var el = getDrawer();
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function initDrawer() {
    var el = getDrawer();
    if (!el) return;
    if (!el.dataset.avfBound) {
      el.dataset.avfBound = '1';
      el.addEventListener('click', function (event) {
        if (event.target.closest('[data-cart-close]') || event.target.hasAttribute('data-cart-scrim')) {
          closeDrawer();
          return;
        }

        var upsellAdd = event.target.closest('[data-cart-upsell-add]');
        if (upsellAdd) {
          addUpsell(upsellAdd);
          return;
        }

        var row = event.target.closest('[data-cart-line]');
        if (!row) return;
        var line = parseInt(row.getAttribute('data-cart-line'), 10);
        if (!line) return;

        var current = parseInt((row.querySelector('[data-cart-qty]') || {}).textContent, 10) || 1;

        if (event.target.closest('[data-cart-remove]')) changeLine(line, 0);
        else if (event.target.closest('[data-cart-plus]')) changeLine(line, current + 1);
        else if (event.target.closest('[data-cart-minus]')) changeLine(line, current - 1);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeDrawer();
      });
    }
    document.querySelectorAll('[data-cart-open]').forEach(function (trigger) {
      if (trigger.dataset.avfBound) return;
      trigger.dataset.avfBound = '1';
      trigger.addEventListener('click', function (event) {
        if (!getDrawer()) return;
        event.preventDefault();
        refreshCart().then(openDrawer);
      });
    });
  }

  function money(cents) {
    var format = settings.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withComma = parts.join('.');
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, parts[0]);
  }

  /* Cart lines come back from cart.js as raw strings. Anything interpolated
     into the drawer's markup is escaped here rather than trusted, because a
     product or variant title is merchant-authored and may carry quotes. */
  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var strings = {
    decrease: (settings.strings && settings.strings.decrease) || 'Decrease quantity',
    increase: (settings.strings && settings.strings.increase) || 'Increase quantity',
    remove: (settings.strings && settings.strings.remove) || 'Remove'
  };

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = cart.item_count;
      node.hidden = cart.item_count === 0;
    });

    var list = document.querySelector('[data-cart-items]');
    if (!list) return;

    if (!cart.items.length) {
      list.innerHTML = '<p class="empty-state">' + (settings.strings.cartEmpty || 'Your cart is empty.') + '</p>';
    } else {
      list.innerHTML = cart.items.map(function (item, index) {
        var image = item.image
          ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_136x$1$2') + '" alt="" width="68" height="68" loading="lazy">'
          : '<span class="cart-drawer__noimage" aria-hidden="true"></span>';

        return '<div class="cart-drawer__item" data-cart-line="' + (index + 1) + '">' + image +
          '<div class="cart-drawer__detail">' +
            '<a class="cart-drawer__name" href="' + item.url + '">' + esc(item.product_title) + '</a>' +
            (item.variant_title ? '<div class="cart-drawer__variant">' + esc(item.variant_title) + '</div>' : '') +
            '<div class="cart-drawer__stepper">' +
              '<button type="button" data-cart-minus aria-label="' + esc(strings.decrease) + '">&minus;</button>' +
              '<span data-cart-qty aria-live="polite">' + item.quantity + '</span>' +
              '<button type="button" data-cart-plus aria-label="' + esc(strings.increase) + '">+</button>' +
              '<button type="button" class="cart-drawer__remove" data-cart-remove>' + esc(strings.remove) + '</button>' +
            '</div>' +
          '</div>' +
          '<b class="cart-drawer__price">' + money(item.final_line_price) + '</b></div>';
      }).join('');
    }

    var total = document.querySelector('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);

    syncUpsell(cart);
  }

  /* The offer is withdrawn the moment it is taken, and never made over an
     empty cart. The row itself is untouched by the re-render above, so only
     its hidden attribute has to move. */
  function syncUpsell(cart) {
    var upsell = document.querySelector('[data-cart-upsell]');
    if (!upsell) return;

    var wanted = upsell.getAttribute('data-cart-upsell-variant');
    var present = (cart.items || []).some(function (item) {
      return String(item.variant_id) === String(wanted);
    });

    upsell.hidden = present || !(cart.items || []).length;
  }

  function addUpsell(button) {
    var upsell = button.closest('[data-cart-upsell]');
    if (!upsell || button.disabled) return;

    var id = upsell.getAttribute('data-cart-upsell-variant');
    if (!id) return;

    var label = button.dataset.label || button.textContent;
    button.disabled = true;
    button.textContent = settings.strings && settings.strings.adding ? settings.strings.adding : 'Adding…';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (response) { return response.json(); })
      .then(function () { return refreshCart(); })
      .catch(function () { return refreshCart(); })
      .then(function () {
        button.disabled = false;
        button.textContent = label;
      });
  }

  function refreshCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { return null; });
  }

  /* A line is addressed by its 1-based position rather than its key, because
     the drawer re-renders from the response every time and positions stay in
     step with what was just drawn. Quantity 0 removes the line. */
  function changeLine(line, quantity) {
    var el = getDrawer();
    if (el) el.classList.add('is-busy');
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { return refreshCart(); })
      .then(function (cart) {
        if (el) el.classList.remove('is-busy');
        return cart;
      });
  }

  /* --------------------------------------------------------- add to cart */
  function initAddToCart() {
    document.querySelectorAll('form[data-add-to-cart], form.js-ajax-cart').forEach(function (form) {
      if (form.dataset.avfBound) return;
      form.dataset.avfBound = '1';
      form.addEventListener('submit', function (event) {
        if (!window.fetch || settings.cartAction === 'page') return;
        event.preventDefault();

        var button = form.querySelector('[type="submit"]');
        var original = button ? button.textContent : '';
        if (button) { button.disabled = true; button.textContent = settings.strings.adding || 'Adding…'; }

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) { return response.json().then(function (body) { return { ok: response.ok, body: body }; }); })
          .then(function (result) {
            if (!result.ok) throw new Error(result.body.description || result.body.message);
            return refreshCart();
          })
          .then(function () {
            if (button) { button.disabled = false; button.textContent = original; }
            if (!openDrawer()) window.location.href = window.Shopify.routes.root + 'cart';
          })
          .catch(function (error) {
            if (button) { button.disabled = false; button.textContent = original; }
            var slot = form.querySelector('[data-cart-error]');
            if (slot) slot.textContent = error.message;
            else window.alert(error.message);
          });
      });
    });
  }

  /* ------------------------------------------------------------ quantity */
  function initQuantity() {
    document.querySelectorAll('[data-qty]').forEach(function (widget) {
      if (widget.dataset.avfBound) return;
      widget.dataset.avfBound = '1';
      var input = widget.querySelector('input');
      widget.querySelectorAll('button').forEach(function (button) {
        button.addEventListener('click', function () {
          var step = button.dataset.qtyStep === 'up' ? 1 : -1;
          var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ------------------------------------------------------- product variants */
  function initVariants() {
    document.querySelectorAll('[data-product-form]').forEach(function (root) {
      if (root.dataset.avfBound) return;
      root.dataset.avfBound = '1';
      var data = root.querySelector('[data-variants]');
      if (!data) return;

      var variants = JSON.parse(data.textContent);
      var idInput = root.querySelector('[data-variant-id]');
      var priceEl = root.querySelector('[data-variant-price]');
      var compareEl = root.querySelector('[data-variant-compare]');
      var submit = root.querySelector('[type="submit"]');
      var gallery = document.querySelector('[data-gallery-main]');

      function selected() {
        return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      function update() {
        var options = selected();
        var match = variants.find(function (variant) {
          return variant.options.every(function (option, index) { return option === options[index]; });
        });

        if (!match) {
          if (submit) { submit.disabled = true; submit.textContent = settings.strings.unavailable || 'Unavailable'; }
          return;
        }

        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (compareEl) {
          var onSale = match.compare_at_price && match.compare_at_price > match.price;
          compareEl.textContent = onSale ? money(match.compare_at_price) : '';
          compareEl.hidden = !onSale;
        }
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available ? (settings.strings.addToCart || 'Add to cart') : (settings.strings.soldOut || 'Sold out');
        }
        if (gallery && match.featured_image) {
          var img = gallery.querySelector('img');
          if (img) { img.src = match.featured_image; img.srcset = ''; }
        }
        if (window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      root.addEventListener('change', function (event) {
        if (event.target.matches('input[type="radio"], select')) update();
      });
      update();
    });
  }

  /* -------------------------------------------------------------- gallery */
  function initGallery() {
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      if (thumb.dataset.avfBound) return;
      thumb.dataset.avfBound = '1';
      thumb.addEventListener('click', function () {
        var img = main.querySelector('img');
        if (!img) return;
        img.src = thumb.dataset.galleryThumb;
        img.srcset = '';
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (other) {
          other.setAttribute('aria-current', String(other === thumb));
        });
      });
    });
  }

  /* A card video is decoration, so it should not start for anyone who has
     asked the OS for reduced motion. Autoplay is removed rather than only
     paused, or the browser restarts it on the next paint. */
  function initQuietVideo() {
    if (!reduceMotion) return;
    Array.prototype.forEach.call(document.querySelectorAll('video[autoplay]'), function (v) {
      v.removeAttribute('autoplay');
      v.pause();
    });
  }

  /* The drawer lives in this file, but the product page runs its own
     add-to-cart (its button holds markup a textContent swap would destroy).
     That handler needs a way in, so the drawer's controls are published here
     rather than duplicated there. */
  window.AVFCart = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshCart,
    changeLine: changeLine,
    refreshAndOpen: function () {
      return refreshCart().then(function () { return openDrawer(); });
    }
  };

  /* --------------------------------------------------- header balance
     The split header centres its logo by reserving a spacer column the exact
     width of the cart cluster on the other side. Only the browser knows that
     width — it changes with the currency label, whether the account icon is
     shown, and the font once it loads — so it is measured and published as a
     custom property. Without this the CSS falls back to 0px and the logo sits
     slightly left, which is the old behaviour rather than a broken one. */
  function initHeaderBalance() {
    var bars = document.querySelectorAll('.site-header__bar--split');
    if (!bars.length) return;

    function measure() {
      bars.forEach(function (bar) {
        var utils = bar.querySelector('.site-header__utils');
        if (!utils) return;
        /* Below the breakpoint the spacer is unused and the toggle changes the
           cluster's width, so publishing it there would only cause reflow. */
        if (window.innerWidth < 991) {
          bar.style.removeProperty('--utils-w');
          return;
        }
        bar.style.setProperty('--utils-w', Math.round(utils.getBoundingClientRect().width) + 'px');
      });
    }

    measure();

    if (window.ResizeObserver) {
      var ro = new ResizeObserver(measure);
      bars.forEach(function (bar) {
        var utils = bar.querySelector('.site-header__utils');
        if (utils) ro.observe(utils);
      });
    }
    window.addEventListener('resize', measure);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  }

  function init() {
    initQuietVideo();
    initReveal();
    initHeader();
    initHeaderBalance();
    initAccordions();
    initBackToTop();
    initDrawer();
    initAddToCart();
    initQuantity();
    initVariants();
    initGallery();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // The theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
